// userRolesService.js
import { SDCloudBackendAPIWithToken } from "apis/backendAPI";

export async function fetchUserPermission(permission_profile_name) {
  try {
    const res = await SDCloudBackendAPIWithToken().post("check_permission", {
      profile_name: permission_profile_name,
    });
    return res?.data === true;
  } catch (error) {
    console.error("Failed to check user permission", error);
    throw error;
  }
}

export async function fetchUserRoles(username,current_user=true) {
  try {
     if (username &&current_user){sessionStorage.setItem("username", username)}
    const res = await SDCloudBackendAPIWithToken().get(
      `get_user_assigned_roles?username=${username}`
    );
    const userData = res?.data?.response_data || {};

    const { enabled_roles = [], disabled_roles = [] } = getAssignedNames(userData) || {}
    if (current_user) {
    // optional: cache in sessionStorage
   
    sessionStorage.setItem("enabled_roles", JSON.stringify(enabled_roles));
    sessionStorage.setItem("disabled_roles", JSON.stringify(disabled_roles));
    }
    return {enabled_roles,disabled_roles};
  } catch (error) {
    console.error("Failed to load user roles", error);
    throw error;
  }
}
export async function fetchUserRolesInAccount() {
  try {
    const res = await SDCloudBackendAPIWithToken().get(
      `get_account_roles`
    );
    const userData = res?.data?.response_data || {};
    if (!Array.isArray(userData) || userData.length === 0){
      return []
    }

    const  enabled_roles  = userData.map(item => item.name)

    // optional: cache in sessionStorage
    sessionStorage.setItem("enabled_roles_in_account", JSON.stringify(enabled_roles));

    return enabled_roles;
  } catch (error) {
    console.error("Failed to load user roles", error);
    throw error;
  }
}
export function getAssignedNames(items) {
  let enabled_roles = [];
  let disabled_roles = [];
  for (const item of items) {
    if (item.attached) {
      enabled_roles.push(item.name);
    }else{
        disabled_roles.push(item.name)
    }
    // if (item.children && item.children.length > 0) {
    //   result = result.concat(getAssignedNames(item.children));
    // }
  }
   return { enabled_roles, disabled_roles };
}